<template id='#app'>
<router-view></router-view>
</template>

<script>
export default {
    name: 'home',
}
</script>
